import { InjectionToken } from '@angular/core';

import { IAccordionItemDirective } from './iAccordionItemDirective';

export const IAccordionDirectiveInjectionToken = new InjectionToken<IAccordionDirective>(
  'IAccordionDirective'
);

export interface IAccordionDirective {
  addLink(link: IAccordionItemDirective): void;
  checkOpenLinks(): void;
  closeOtherLinks(openLink: IAccordionItemDirective): void;
  ngAfterContentChecked(): void;
  removeGroup(link: IAccordionItemDirective): void;
}
